{
	"add-trackingnumber": "Add tracking number.",
	"confirm-trackingnumber": "Confirm tracking number",
	"contentDescription": "Content description",
	"contentsDescription": "Here you can write description of the contents or other info",
	"conent-max": "Can't be longer than 255 characters",
	"delivery": "Delivery",
	"email": "Email of recipient",
	"email-invalid": "Invalid email address",
	"enter-shipment-code": "Enter tracking number.",
	"errorWithTrackingnumber": "Error with tracking number",
	"evaluateDescription": "Instructions",
	"file-min": "At least 1 file",
	"foreign-social-id": "I do not have an Icelandic social ID",
	"gift": "The shipment is a gift (Have to specify for customs official why it is a gift)",
	"hasBeenPayed": "Shipment has been payed for",
	"iDontHaveReceipt": "I don't have receipt, or the shipment is a gift",
	"ifWeNeedMore": "If we need more information from you we will contact you within 2 days",
	"iHaveReceipt": "I have receipt",
	"infoText": "Attention if the tracking number starts with PR and ends with YP the shipment gets a new tracking number which can be found on ",
	"infoTextLink": "www.packageradar.com",
	"infoTextPhone": "It is important to add a mobile phone number so we can send you notifications and for us to be able to deliver your parcel via Póstbox or Pakkaport parcel lockers.",
	"instructions": "Instructions to postal staff",
	"moreThanOneTrackingnumber": "You can send in many tracking numbers",
	"name": "Name of recipient",
	"next-step": "Next step",
	"notArrived": "Shipment hasn't arrived to customs yet",
	"notFound": "Tracking number not found, try again",
	"notInStock": "Shipment has left customs",
	"other": "Other (type explanation in field other. If it is requested that Iceland Post open or examine the shipment, we reserve the right to charge a fee of ISK 990)",
	"permissionToOpen": "I give postal staff permission to access my shipment (990 kr.)",
	"phone": "Mobile Phone of recipient",
	"phone-invalid": "Invalid phone number",
	"phone-max": "Max 15 digits",
	"phone-min": "At least 7 digits",
	"processTime": "Shipment will go through customs and then processed",
	"required": "Field is required",
	"social-id": "Social Id of recipient",
	"upsell": "Simplify the process of receiving shipments by signing up for automatic payments and parcel lockers on ",
	"upsell2": "My account login",
	"ssn-min": "At least 10 digits",
	"ssn-valid": "Social ID is not valid",
	"submit": "Submit",
	"trackingnumber-min": "At least 1 tracking number",
	"get-shipment": "Get shipment",
	"info": "By filling out this request you grant Iceland Post permission to clear your shipment through Customs. If the shipment worth is over 40,000ISK it will automatically go through E1 paperwork ",
	"seeCalculator": "see calculator",
	"info2": "If you submit the request before 11:30 AM you can request express handling and your shipment will be delivered the same day to post office in the capital area. If you submit the request after 11:30 AM or you live outside the capital area, your shipment will be delivered to post office the next working day.",
	"validReceipt": "For the invoice to be sufficient, it needs to contain product description, total price and delivery/shipping fee.",
	"name-invalid": "Invalid name"
}